import React from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function DareInfoModal({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-70" />
        <div className="relative bg-gray-900 text-white rounded-xl p-6 sm:p-8 w-[90vw] max-w-sm text-center z-50 border-2 border-red-600 shadow-2xl">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-300 hover:text-white"
            aria-label="Close"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>

          <Dialog.Title className="text-xl font-bold text-red-400 mb-2">
            Dare Wheel 🔥
          </Dialog.Title>
          <Dialog.Description className="text-sm text-gray-300">
            You just won BIG... but are you greedy enough to risk it all?
            <br /><br />
            The Dare Wheel gives you a shot at even bigger prizes — like 2x or 3x multipliers — 
            but you could also lose everything, or get trolled by fate.
            <br /><br />
            Spin it only if you dare. 😈
          </Dialog.Description>
        </div>
      </div>
    </Dialog>
  );
}
